/**
 *
 */
export enum RejectTenantReason {
  Empty = 0,
  SelectedAnotherCandidate = 1,
  NotMatchingPreferences = 2,
  OtherReason = 3,
}
